import { isAxiosError } from 'axios';

// Swallows a UUID (and any space leading up to it) so internal identifiers are not shown to the
// user, e.g. "...update provider <uuid>." becomes "...update provider.".
const UUID_PATTERN = /\s*\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi;

/**
 * Extracts the user-readable `message` from a provider update API error response, with provider
 * UUIDs stripped out. Returns `undefined` when the error carries no usable message (or nothing
 * readable survives redaction), so callers can fall back to a generic message.
 */
export function getProviderUpdateErrorMessage(error: unknown): string | undefined {
    // Use axios's runtime guard rather than `instanceof`, which can miss errors when multiple axios
    // copies are bundled.
    const message = isAxiosError(error) ? error.response?.data?.message : undefined;
    if (typeof message !== 'string' || !message.trim()) return undefined;
    const sanitized = message
        .replace(UUID_PATTERN, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
    // A message that was nothing but a UUID redacts to an empty string; return undefined so the
    // caller's generic fallback shows instead of a blank toast.
    return sanitized || undefined;
}
